<app-group-edit *ngIf="selectedGroup; else listBlock" [group]="selectedGroup"></app-group-edit>

<ng-template #listBlock>
    <app-groups-list [groups]="groups"></app-groups-list>
    <app-groups-list [groups]="publicGroups" [isEditable]="false" [doesShowPublic]="false"></app-groups-list>
</ng-template>

